var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTotalTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 34,
    viewBox: "0 0 45 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_7475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4216 19.1083C38.6115 18.7639 38.5432 18.3201 38.2393 17.9987C37.9355 17.792 37.4949 17.7767 37.1759 18.0216L30.4228 23.1182C30.1342 23.3401 29.9519 23.7227 30.1266 24.0671C30.2405 24.4114 30.5595 24.6487 30.9318 24.6487H33.4309L31.3116 28.4902C31.1217 28.8346 31.19 29.2784 31.4939 29.5386C31.7977 29.8064 32.2383 29.7605 32.5574 29.5845L39.3104 24.488C39.599 24.266 39.7206 23.8834 39.6066 23.5391C39.4927 23.1947 39.1737 22.9575 38.8014 22.9575H36.3023L38.4216 19.1159V19.1083ZM44.9924 23.7992C44.9924 29.4315 40.4574 34 34.8666 34C29.2758 34 24.7408 29.4315 24.7408 23.7992C24.7408 18.167 29.2758 13.5985 34.8666 13.5985C40.4574 13.5985 44.9924 18.167 44.9924 23.7992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75301 20.4015C7.99879 20.4015 9.00149 19.3914 9.00149 18.1364C9.00149 16.8814 7.99879 15.8713 6.75301 15.8713C5.50723 15.8713 4.50453 16.8814 4.50453 18.1364C4.50453 19.3914 5.51483 20.4015 6.75301 20.4015ZM11.6298 4.53027C10.6727 4.53027 9.82188 5.14247 9.50284 6.04546L7.66456 11.3257H28.3187L26.4804 6.04546C26.1614 5.14247 25.3106 4.53027 24.3535 4.53027H11.6298ZM11.6298 0H24.3686C27.24 0 29.7923 1.82894 30.7419 4.55323L33.1423 11.4558C27.1337 12.3052 22.5076 17.5089 22.5076 23.7992C22.5076 24.5721 22.5076 25.3297 22.7127 26.0644H6.75301V29.4621C6.75301 30.7171 5.74271 31.7272 4.50453 31.7272H2.25605C1.01027 31.7272 0.00756836 30.7171 0.00756836 29.4621V15.8636C0.00756836 13.9734 1.1546 12.3511 2.79538 11.67L5.27175 4.55323C6.20608 1.82894 8.75841 0 11.6298 0Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_7475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTotalTransactions);
export default __webpack_public_path__ + "static/media/ic_total_transactions.172829701c820cc2f2640ed07fb3908a.svg";
export { ForwardRef as ReactComponent };